import { useFormikContext,getIn } from 'formik';
import React, { useState, useEffect } from 'react';
import { useEdit } from '../../Services/EditContext';
import useFetch from '../../Services/useFetch';
import { authEndpoints } from '../../utils/Constants';
import { FormLabel, FormValue } from './FormLabel';
import Selector from './Selector';
import ErrorMessage from './ErrorMessage'
const SupplierLocationSelector = (props) => {
    const { label, id,isMulti, showError = true } = props;
    const [selection, setSelection] = useState();
    const [options, setOptions] = useState([]);
    const { setFieldValue, values } = useFormikContext();
   
    const [states, loading, error] = useFetch(authEndpoints.getLocationStates);
    const value = getIn(values,id)
    const [edit] = useEdit();
    useEffect(() => {

        const options = states ? states.map((m) => { return { id: m.id, value: m.code, label: m.name + ' - ' + m.code,}; }) : [];
        setOptions(options)
    }, [states]);
    useEffect(() => {
        if (options && options.length) {
            if (value) {
                const newOps = isMulti ? value.map(x => options.find(y => x === y.id)) : options.find(y => value === y.value)
                    setSelection(newOps)
            }
            else {
                setSelection()
            }
        }
    }, [value, options, isMulti]);

    const onSelectChange = val => {
        if (isMulti) {
            const value = val?.map((x) => x.id);
            setFieldValue(id, value);
        }
        else {
            setFieldValue(id, val.value);
        }
    }
    return <React.Fragment>
        <FormLabel htmlFor={id} style={{ display: 'block' }}>
            {label}
        </FormLabel>      
        {edit && !loading ? <Selector onChange={onSelectChange} isMulti={isMulti} value={selection} options={options} /> : <FormValue>{isMulti ? <ul>{selection?.map((x, i) => <li key={i}>{x?.label}</li>)}</ul> : value}</FormValue>}
          {error ? <h4>Error</h4> : null}
        {showError && <ErrorMessage name={id} />}
    </React.Fragment>
};
export default SupplierLocationSelector;

